import { IconTrash } from "app/components/Icon/Icon";
import React from "react";
import "./FileSelected.scss";

type Props = {
  onRemoveFile: (...args: Array<any>) => any;
  selectedFileName: string;
};

const FileSelected: React.FC<Props> = ({ selectedFileName, onRemoveFile }) => (
  <div className="documents__form__selected-file">
    <span>{selectedFileName}</span>
    <div onClick={() => onRemoveFile()}>
      <IconTrash />
    </div>
  </div>
);

export default FileSelected;
